import React from "react";
import PropTypes from "prop-types"; // Import PropTypes for prop validation

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    // Define a state variable to track whether there is an error or not
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(_, errorInfo) {
    // Use your own error logging service here
    console.log({ errorInfo });
  }

  render() {
    // Check if an error is thrown
    if (this.state.hasError) {
      // Render any custom fallback UI
      return (
        <div className="raqtaq" style={{ padding: `200px 50px`, textAlign: `center` }}>
          <div className="browseAll2">
            <div
              className="homeUneCardPix"
              style={{ backgroundImage: `url('https://sunulife.com/reload.webp')` }}
            ></div>
          </div>
        </div>
      );
    }
    // Return children components in case of no error
    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired, // Add validation for the `children` prop
};

export default ErrorBoundary;
